// extracted by mini-css-extract-plugin
export var boldText = "_5k-4";
export var checkboxContainer = "_5k-6";
export var closeIcon = "_5k-i";
export var container = "_5k-0";
export var drawer = "_5k-8";
export var drawerContent = "_5k-9";
export var extraSmallText = "_5k-5";
export var fulfillmentGroupTable = "_5k-e";
export var largeText = "_5k-3";
export var loadingSpinnerContainer = "_5k-j";
export var mediumText = "_5k-2";
export var narrow = "_5k-f";
export var notificationLink = "_5k-l";
export var packageCheckIconContainer = "_5k-7";
export var slideoutHeaderActions = "_5k-g";
export var slideoutHeaderActionsShifted = "_5k-h";
export var slideoutHeaderContainer = "_5k-a";
export var slideoutModal = "_5k-c";
export var stickyHeaderWrapper = "_5k-b";
export var table = "_5k-k";
export var tableContainer = "_5k-d";
export var tertiaryText = "_5k-1";